import React from 'react';
import WhatWeDo from '../components/WhatWeDo';
import HowWeWork from '../components/HowWeWork';
import MiniStats from '../components/MiniStats';
import DiversifySection from '../components/DiversifySection';

function WhatWeDoPage() {
  return (
    <div className="page">
      <WhatWeDo />
      <HowWeWork />
      <MiniStats />
      <DiversifySection />
    </div>
  );
}

export default WhatWeDoPage;
